/* eslint-disable @next/next/no-img-element */
import react, { useState } from "react";
import { EyeIcon } from "@heroicons/react/outline";
import { ModalBase, LazyLoadedImage } from "@reusejs/react";
import ImagePreviewSlider from "./ImagePreviewSlider";
import { getWatermarkedImgixUrl } from "services";

function ImagePreview(props: any) {
  const [selctedImageIndex, setSelectedImageIndex] = useState(0);

  const ImageGallery = (propsa: any) => {
    return (
      <ImagePreviewSlider property_images={props.property_images} {...propsa} />
    );
  };

  const openModal = async () => {
    await ModalBase(
      {
        content: ImageGallery,
        timeout: 0,
        backgroundColor: "bg-black",
        backgroundOpacity: "opacity-80",
        modalBaseClasses: {
          background: "bg-transparent",
          border: "",
          alignment: "z-50 overflow-visible",
          padding: "p-0",
          small: "min-w-full h-screen ",
        },
      },
      1000,
      "__next",
    );
  };

  return (
    <div className="relative py-4 sm:py-16 lg:py-0">
      <div className="relative h-[200px] md:h-[400px] mx-auto max-w-md px-4 md:max-w-2xl lg:px-0 lg:max-w-none lg:py-5 w-fit">
        <div className="relative h-full flex items-end pb-4 rounded-lg shadow-xl overflow-hidden w-[288px] md:w-[600px] lg:w-[500px] xl:w-[600px]">
          <div className="absolute inset-0 h-full w-fit object-cover">
            {props.property_images && props.property_images.length > 0 ? (
              <img
                src={getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.property_images[selctedImageIndex].key_path}?fit=fill&auto=format`,
                )}
                alt={
                  props.property?.asset?.name === "Residential"
                    ? getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/da22bbb4-00d3-4817-9a4b-416c902bd434?fit=fill&auto=format`,
                      )
                    : props.property?.asset?.name === "Aggricultural"
                    ? getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/d18b7220-f879-4aac-b5ee-8c8bc0fb503b?fit=fill&auto=format`,
                      )
                    : getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/159e0109-0a4e-40c8-aedc-6daaafbc6187?fit=fill&auto=format`,
                      )
                }
              />
            ) : (
              <LazyLoadedImage
                width={600}
                height={360}
                placeholderSrc={
                  props.property?.asset?.name === "Residential"
                    ? getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/da22bbb4-00d3-4817-9a4b-416c902bd434?fit=fill&auto=format`,
                      )
                    : props.property?.asset?.name === "Aggricultural"
                    ? getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/d18b7220-f879-4aac-b5ee-8c8bc0fb503b?fit=fill&auto=format`,
                      )
                    : getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/159e0109-0a4e-40c8-aedc-6daaafbc6187?fit=fill&auto=format`,
                      )
                }
              />
            )}
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-gray-600 opacity-80" />
          <div className="absolute w-full flex justify-between px-2 sm:px-4  md:flex-grow">
            <div className="flex flex-col">
              <div className="text-xs sm:text-sm text-white">
                {`${
                  props.interestedCount === 0
                    ? props.interestedCount
                    : props.interestedCount + "+"
                } People are interested`}
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center text-xs sm:text-sm text-white">
                <EyeIcon className="mr-1 h-3 w-3 sm:h-5 sm:w-5" />
                {`${
                  props.viewCount === 0
                    ? props.viewCount
                    : props.viewCount + "+"
                } Views`}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 sm:mt-0 grid grid-cols-4 gap-1 h-20 sm:block sm:h-28 lg:grid lg:grid-cols-4 lg:gap-4 overflow-hidden">
        {props.property_images &&
          props.property_images.length > 0 &&
          props.property_images.map((item: any, index: any) => {
            return (
              <div
                className="w-16 h-20 sm:w-full relative sm:h-[100px] mx-auto"
                key={index}
              >
                <div className="relative h-full flex items-center rounded-sm shadow-xs overflow-hidden">
                  <div
                    className="absolute cursor-pointer inset-0 h-full w-full object-cover"
                    onClick={() => setSelectedImageIndex(index)}
                  >
                    <img
                      src={getWatermarkedImgixUrl(
                        `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${item.key_path}?fit=fill&auto=format`,
                      )}
                      width={138}
                      height={94}
                      alt={
                        props.property?.asset?.name === "Residential"
                          ? getWatermarkedImgixUrl(
                              `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/da22bbb4-00d3-4817-9a4b-416c902bd434?fit=fill&auto=format`,
                            )
                          : props.property?.asset?.name === "Aggricultural"
                          ? getWatermarkedImgixUrl(
                              `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/d18b7220-f879-4aac-b5ee-8c8bc0fb503b?fit=fill&auto=format`,
                            )
                          : getWatermarkedImgixUrl(
                              `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/159e0109-0a4e-40c8-aedc-6daaafbc6187?fit=fill&auto=format`,
                            )
                      }
                    />
                  </div>

                  {(props.property_images.length <= 4 &&
                    index === props.property_images.length - 1) ||
                    (props.property_images.length > 4 && index === 3 && (
                      <>
                        <div
                          className="absolute cursor-pointer inset-0 bg-gradient-to-t from-gray-900"
                          onClick={() => openModal()}
                        />

                        <div
                          className="relative cursor-pointer flex justify-center px-4  md:flex-grow"
                          onClick={() => openModal()}
                        >
                          <div className="flex flex-col">
                            <div className="text-xs sm:text-sm text-white">{`${
                              props.property_images.length - 1
                            }+ Photos`}</div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default ImagePreview;
